module.exports = __webpack_public_path__ + "static/gift-box-53626b537820aceffc060b8c06628629.png";